import { contentApi } from '@/infrastructure/Configuration'

export default class HotelService {
  constructor (httpClient) {
    this._httpClient = httpClient
  }

  async getHotel (hotelCode) {
    const url = `${contentApi}/hotels/${hotelCode}`
    const {
      data: { hotel }
    } = await this._httpClient.get(url)
    return hotel
  }

  async getHotelDistance (hotelCode) {
    const url = `${contentApi}/multiple-hotels-distance?hotelCodes=${hotelCode}`
    const {
      data: { hotels }
    } = await this._httpClient.get(url)
    return hotels
  }
}
